import React, { Component } from "react";
import { Header, TopBar, BottomBar } from "../../layouts/_admin/general/index";

class Admin_Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "/assets/img/logo-small.png",
          names: "Home",
        },
      ],
    };
  }

  render() {
    /*
    database.ref("News").once("value", (snapshot) => {
      var news = [];
      snapshot.forEach(function (childSnapshot) {
        var id = childSnapshot.id;
        var data = childSnapshot.val();
        // ...
        news.push({ id: id, title: data.title, description: data.description });
        this.setState({ news: news });
      });
    });
    */

    return (
      <div className="header-fixed page no-sidebar header-style-2 topbar-style-2 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap">
                <div id="site-content" className="site-content clearfix">
                  <div id="inner-content" className="inner-content-wrap">
                    <div className="page-content"></div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Admin_Home;
